import { LegalEntityClassificationApiModel } from "../../../legalEntity/legalEntityClassificationTab/LegalEntityClassificationTab.types";
import { IProcessingActivityClassificationTabProps } from "./ProcessingActivityClassificationTab";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useProcessingActivityClassificationTabHooks(props: IProcessingActivityClassificationTabProps) {
    const url = `/ProcessingActivityOverview/${props.processingActivityId}/classifications`;
    let { isLoading, data, refetch } = useDotLegalQuery<LegalEntityClassificationApiModel>(url);
    return {
        isLoading,
        data,
        refetch,
    };
}
